(() => {
  if (window.momVersoPreviewInitialized) return;
  window.momVersoPreviewInitialized = true;
  const families = {'Playball':'Playball, cursive','Times New Roman':'Times New Roman, serif','Montserrat':'Montserrat, sans-serif','Great Vibes':'Great Vibes, cursive'};
  function initialize() {
    document.querySelectorAll('[data-mom-preview]').forEach(root => {
      if (root.dataset.momReady) return;
      const input = document.getElementById(root.dataset.inputId);
      if (!input) return;
      root.dataset.momReady = 'true';
      const scope = root.closest('[id^="MainProduct-"]') || root.closest('section') || document;
      const font = root.querySelector('[data-mom-font]');
      const text = root.querySelector('[data-mom-text]');
      const placeholder = text.textContent;
      const refresh = () => {
        const active = input.required && !input.disabled;
        root.hidden = !active;
        font.disabled = !active;
        font.required = active;
        root.querySelector('[data-mom-counter]').textContent = `${input.value.length}/20`;
        text.textContent = input.value.trim() || placeholder;
        text.style.fontFamily = families[font.value] || families.Montserrat;
        const value = (scope.querySelector('input[name="Couleur"]:checked,select[name="options[Couleur]"]')?.value || 'Or').toLowerCase();
        const palette = /rose/.test(value) ? ['#fff0e6','#e8b99d','#ae775c'] : /argent|silver/.test(value) ? ['#fff','#d7d9df','#9297a0'] : ['#fff2bb','#e7c76f','#b08a35'];
        ['light','base','dark'].forEach((key,index) => root.style.setProperty(`--mom-${key}`,palette[index]));
        if (!active) return;
        let size = /Playball|Great Vibes/.test(font.value) ? 42 : 32;
        text.setAttribute('font-size',size);
        while (text.getComputedTextLength() > 154 && size > 8) text.setAttribute('font-size',--size);
      };
      input.addEventListener('input',refresh);
      scope.addEventListener('change',refresh);
      window.addEventListener('resize',refresh);
      document.fonts?.addEventListener('loadingdone',refresh);
      if (document.fonts?.ready) document.fonts.ready.then(refresh);
      refresh();
    });
  }
  document.addEventListener('shopify:section:load',initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
